import styled from '@emotion/styled'
import { observer } from 'mobx-react'
import type { ComponentPropsWithRef } from 'react'

import { useStudentAppMediaQuery } from '~/@common/hooks/useMediaQuery'
import { commonRepo } from '~/@common/services/repo.service'
import { mediaQuery } from '~/@common/styles/mediaQuery'
import { Icon } from '~/@common/ui/Icon/Icon'

interface Props {
  onClick?: ComponentPropsWithRef<'button'>['onClick']
  selectedMiddleChapterId: number | null
  resetSelectedMiddleChapterId: () => void
}

const ChapterSearchButton = ({
  onClick,
  selectedMiddleChapterId,
  resetSelectedMiddleChapterId,
}: Props) => {
  const { isMobile } = useStudentAppMediaQuery()
  const isElementarySchoolflat = commonRepo.isElementarySchoolflat && !isMobile

  return selectedMiddleChapterId ? (
    <S.Button onClick={onClick} className="selected">
      <p>단원 검색됨</p>
      <Icon
        name="icon_close"
        size={16}
        color="var(--Colors-Blue-600)"
        onClick={(e) => {
          e.stopPropagation()
          resetSelectedMiddleChapterId()
        }}
      />
    </S.Button>
  ) : (
    <S.Button onClick={onClick} className={isElementarySchoolflat ? 'border' : undefined}>
      <p>단원 검색</p>
      <Icon
        name="icon_search"
        size={16}
        color={isMobile ? 'var(--Colors-Gray-700)' : 'var(--Colors-Gray-900)'}
      />
    </S.Button>
  )
}

export default observer(ChapterSearchButton)

const S = {
  Button: styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    padding: 0 16px;
    min-width: 105px;
    height: 40px;
    color: var(--Colors-Gray-900);
    background-color: var(--Colors-Gray-100);
    font-size: 14px;
    border-radius: var(--Radius-Circle);
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
    cursor: pointer;

    &.selected {
      min-width: 118px;
      color: var(--Colors-Blue-600);
      background-color: var(--Colors-Gray-100);
      border: 1px solid var(--Colors-Blue-600);
      font-weight: 700;
    }

    &.border {
      border: 1px solid var(--Colors-Gray-400);
      background-color: var(--White);
      box-shadow: none;
    }

    ${mediaQuery.underTablet} {
      width: 100%;
      border-radius: var(--Radius-200);
      color: var(--Colors-Gray-700);
      background-color: var(--White);
      box-shadow: none;
    }
  `,
}
